<woo-modal-layout size="medium" [closable]="true" (close)="close()">
  <h3 header>Du kan söka på:</h3>
    <h4>För alla kampanjer</h4>
    <p>Namn, referensnummer, fakturareferens, region, publicist, programformat, målgrupp, apparat, filmkod, filmnamn</p>
    <p>Kund- eller byrånamn, organisationsnummer för kund eller byrå</p>
  <br>
  <br>
  <h4>Magiska söktermer</h4>
  <p>Pausreklam, spelbolag, startvecka (ex v24), adresserbartv, onlinevideo, kombination, politik, tilläggsstyrning</p>
</woo-modal-layout>
  